<template>
  <b-overlay :show="show" rounded="sm">
    <span>
      <b-card no-body>
        <b-card-header>
          <b-row>
            <b-col md="8">
              <h3 tabindex="0">Listar Inscrições</h3>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col sm="12">
              <b-form-group label="Pesquisar...">
                <b-form-input type="text" id="name" v-model="filtros.filter"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group label="Período - Data Início:" for="data_inicio">
                <b-form-input id="data_inicio" v-model="filtros.data_inicio" v-mask="'##/##/####'" type="text"
                  class="form-control" placeholder="Data Início" />
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Periodo - Data Fim:" for="data_final">
                <b-form-input id="data_final" v-model="filtros.data_final" v-mask="'##/##/####'" type="text"
                  class="form-control" placeholder="Data Fim" />
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group label="Situação:">
                <b-form-select v-model="filtros.situacao" class="mb-3">
                  <option selected :value="null"> Selecione </option>
                  <option v-for="situacao in situacoes" :value="situacao.value" :key="situacao.value"> {{ situacao.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>          
          <b-row>
            <b-col sm="2">
              <b-button block @click="limpar">
                <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
              </b-button>
            </b-col>
            <b-col sm="2">
              <b-button block variant="primary" @click="pesquisar">
                <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
        <b-row>
          <b-col sm="12">
            <b-container fluid>
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                  class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th tabindex="0" scope="col" style="width: 10%">Data de Inscrição</th>
                      <th tabindex="0" scope="col" style="width: 10%">Nome da Conferência</th>
                      <th tabindex="0" scope="col" style="width: 10%">Data de Início</th>
                      <th tabindex="0" scope="col" style="width: 10%">Data de Fim</th>
                      <th tabindex="0" scope="col" style="width: 10%">Situação</th>
                      <th tabindex="0" scope="col" style="width: 5%">Ações</th>
                    </tr>
                  </thead>

                  <tbody v-if="participantes.data !== undefined">
                    <tr class="action" v-for="participante in participantes.data" :key="participante.id_user">
                      <td tabindex="0">
                        {{ participante.created_at }}
                      </td>
                      <td tabindex="0">{{ participante.conferencia_nome }}</td>
                      <td tabindex="0">{{ moment(String(participante.inscricao_inicio)).format('DD/MM/YYYY')  }}</td>
                      <td tabindex="0">{{ moment(String(participante.inscricao_termino)).format('DD/MM/YYYY')  }}</td>
                      <td tabindex="0" v-if="participante.situacao === 'P'">Inscrição em Análise</td>
                      <td tabindex="0" v-if="participante.situacao === 'C'">Credenciado</td>
                      <td>
                        <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Visualizar Inscrição"
                          @click="visualizarParticipante(participante.questionario_respondido_id)">
                          <i class="fa fa-search"></i>
                        </b-button>      
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="9" tabindex="0">Nenhum registro de usuários...</td>
                    </tr>
                  </tbody>
                </table>
                <pagination tabindex="0" v-show="participantes.data !== undefined" :totalPorPagina="totalPorPagina"
                  :resource="resource" :filtros="filtros"></pagination>
              </span>
            </b-container>
          </b-col>
        </b-row>        
        
      </b-card>
    </span>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import { DatePicker, setupCalendar } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'
import moment from 'moment'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect,
    moment
  },
  created() {
    if (!this.validaPerfil()) {
      // this.$router.push('/')
    }
    this.$store.dispatch('setListaConferenciasRelacionadas', SessionStorage.get('conferencia_atual_id'))
    this.$store.dispatch('buscarEstadosPorRegiao')
    this.loadFormularios()
  },
  data() {
    return {
      conferencia_id: SessionStorage.get('conferencia_atual_id'),
      totalPorPagina: 50,
      resource: 'participante/usuarios',
      modalCadastrar: false,
      modalCertificar: false,
      modalEmailCertificado: false,
      texto_email_certificado: '',
      perguntas: [],
      modal_perguntas: false,
      participantes_selecionados: [],
      formulario: null,
      modalAlterar: false,
      modalExportar: false,
      modalImportarInscricoes: false,
      loading: false,
      loadingCertificado: false,
      loadingCredenciado: false,
      show: false,
      idEnvio: null,
      filtros: {
        uf: null,
        participacao: null,
        filter: '',
        situacao: null,
        data_inicio: null,
        data_final: null,
        formulario: null,
        perguntas: null,
        respostas: [],
        user_id: SessionStorage.get('usuario') 
      },
      form_importacao: {
        conferencia_relacionada_id: null
      },
      resposta_atual: null,
      opcoes: [],
      pergunta_id: null,
      alternativa_id: null,
      selecionados: [],
      allSelected: false,
      allSelectedCertificado: false,
      options_formularios: [{ value: null, text: 'Selecione' }],
      perguntas_formulario: [],
      perguntas_respostas: [],
      disable_perguntas: true,
      disable_respostas: true,
      disable_buttons: false,
      situacoes: [
        { 'value': 'P', 'text': 'Inscrição em Análise' },
        { 'value': 'C', 'text': 'Credenciado' }
      ],
      modalCadastrar: false,
      participante: {
        nome: '',
        cpf: '',
        email: ''
      }
    }
  },
  computed: {
    participantes() {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          let data = this.$store.state.pagination.getList

          return data
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    conferencias() {
      return this.$store.state.conferencia.conferenciasRelacionadas
    },
    participante() {
      return this.$store.state.participante.participante
    },
  },
  watch: {
    //
  },
  methods: {   
    pesquisar() {
      console.log(this.filtros)
      this.$store.dispatch('getRegistrosSearch', { resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros })
      this.setarFiltros(this.filtros)
    },
    limpar() {
      this.filtros = { filter: null, data_inicial: null, data_final: null, situacao: null, formulario: null }
      this.perguntas_respostas = []
      this.pesquisar()
    },    
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },    
    visualizarParticipante(id) {
      Vue.http.get('api/formulario/visualizarResposta/' + id, {}).then(response => {
        if (response.body.success) {
          window.location.href = response.body.data[0]
        }
      }).catch(e => { })
    },
    resetForm() {
      this.motivo = ''
    },
    abrirmodalCadastrar() {
      this.modalCadastrar = true
    },
    cadastrarParticipante() {
      Vue.http.post('api/formulario/inscricao/cadastrar/' + conferencia, {}).then(response => {
        if (response.body.success) {        
          window.open(response.body.data.url_inscricao, '_blank');
        }else{
          alert(response.body.msg)
        }
      })
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>.multiselect.invalid .multiselect__tags,
.multiselect.invalid .multiselect__tags span,
.multiselect.invalid .multiselect__tags input {
  background: red;
}</style>



// WEBPACK FOOTER //
// src/pages/site/interna/participante/ParticipanteDelegado.vue